// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"6e5ac2a9","233":"dd407c96","287":"6e5ac2a9","461":"6e5ac2a9","746":"6e5ac2a9"}[chunkId] + ".chunk.css";
};